import instance from "./ApiConfig.tsx";
// import store from "../../Config/store.ts"; 
import store from "../../Redux/Store.tsx";
import { hideLoading, showLoading } from "../../Redux/loadingSlice.tsx";

export const baseApiCall = async (config) => {
  if (!config?.skipLoader) {
    store.dispatch(showLoading());
  }
  try {

    const response = await instance(config);

    console.log('response Api', response);

    if (response?.status >= 200 && response?.status < 300) {
      return response?.data;
    } else {
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  } catch (e:any) {
    if (e?.response?.status === 401) {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = "/login";
        return;
      }, 1000);
    }

    console.log('API error', e);
    const errorMessage = e?.response?.data?.message || "An error occurred while making the request.";
    throw new Error(errorMessage);

  }
  finally {
    store.dispatch(hideLoading())
  }
};
